import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import './index.css'
import App from './App'
import Home from './Home'
import Login from './login/Login'
import JoinUsLogin from './join-us/JoinUsLogin'
import JoinUsRegistration from './join-us/JoinUsRegistration'
import JoinUsForgotPassword from './join-us/JoinUsForgotPassword'
import JoinUsResetPassword from './join-us/JoinUsResetPassword'
import SharedPhotosView from './photos/SharedPhotosView'
import { UserContext } from './contexts/UserContext'
import authService from './services/authentication.service'
import SharedDocumentView from './documents/SharedDocumentView'
import SharedMapsView from './maps/shared/SharedMapsView'
import SharedVideosView from './videos/shared/SharedVideosView'
import SharedVideoView from './videos/shared/SharedVideoView'

class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: authService.getAuthenticatedUser(),
      joinUsUser: authService.getAuthenticatedUser(),
    }
  }

  setUser = (u) => {
    this.setState({ user: u, joinUsUser: null })
  }

  setJoinUsUser = (u) => {
    this.setState({ user: null, joinUsUser: u })
  }

  render() {
    return (
      <UserContext.Provider
        value={{
          user: this.state.user,
          joinUsUser: this.state.joinUsUser,
          setUser: this.setUser,
          setJoinUsUser: this.setJoinUsUser,
        }}
      >
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/joinus/login" component={JoinUsLogin} />
            <Route path="/joinus/registration" component={JoinUsRegistration} />
            <Route
              path="/joinus/forgot_password"
              component={JoinUsForgotPassword}
            />
            <Route
              path="/joinus/reset_password"
              component={JoinUsResetPassword}
            />
            <Route path="/share/photos/" component={SharedPhotosView} />
            <Route path="/axiom/share/photos/" component={SharedPhotosView} />
            <Route path="/axiom/share/video/" component={SharedVideoView} />
            <Route path="/axiom/share/videos/" component={SharedVideosView} />
            <Route path="/share/maps/" component={SharedMapsView} />
            <Route path="/axiom/share/maps/" component={SharedMapsView} />
            <Route path="/axiom/share/doc/" component={SharedDocumentView} />
            <Route>
              <App />
            </Route>
          </Switch>
        </Router>
      </UserContext.Provider>
    )
  }
}

ReactDOM.render(<Index />, document.getElementById('root'))
